import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';

const cases = [
  {
    id: 1,
    tag: '美容保養',
    tagColor: '#4CAF50',
    title: '生髮、黑髮果凍條產品',
    subtitle: '針對頭髮健康需求，開發天然植萃機能果凍條',
    img: 'https://readdy.ai/api/search-image?query=hair%20health%20beauty%20supplement%20jelly%20stick%20product%20with%20natural%20plant%20extract%20black%20sesame%20ginger%20ingredients%20on%20clean%20white%20background%20elegant%20packaging%2C%20professional%20product%20photography&width=600&height=400&seq=case-hair-01&orientation=landscape',
    background: '客戶為一家專注頭髮保養的品牌，希望開發一款兼顧口感與功效的果凍條劑型，訴求生髮、固髮與黑髮，目標族群為 35–60 歲有脫髮困擾的消費者。',
    challenge: '天然黑髮原料（如何首烏萃取）氣味較重，需在不影響口感的前提下達成有效含量；同時果凍條劑型對均勻性與穩定性要求高。',
    solution: '康永研發團隊針對風味進行多輪調整，以天然果汁調味掩蓋苦澀感，搭配穩定劑確保每條含量均一，經過多次風味盲測，最終調配出大眾接受度高的美味配方，確保消費者在日常零食補給中，就能輕鬆守護髮絲健康。',
    result: '產品上市後，憑藉者「好入口、易堅持」的特性， 成功於電商品台上架後首月銷售及超過預期，協助品牌建立起完整的居家養護生態系。',
  },
  {
    id: 2,
    tag: '寵物保健',
    tagColor: '#388e3c',
    title: '國內外寵物保健品系列',
    subtitle: '符合飼料添加法規，為毛孩打造天然機能保健品',
    img: 'https://readdy.ai/api/search-image?query=pet%20health%20supplement%20products%20natural%20organic%20dog%20cat%20vitamins%20treats%20on%20light%20background%2C%20cute%20animal%20care%20products%20with%20herbs%20botanical%20ingredients%2C%20professional%20product%20photography&width=600&height=400&seq=case-pet-02&orientation=landscape',
    background: '客戶 為一家 擁有穩定通路的寵物保健品牌，隨著寵物擬人化與精緻養育的趨勢，希望優化既有的寵物保健產品配方，並同時進攻外國市場 ，需要一家熟悉 寵物保健品 相關法規的代工廠協助。',
    challenge: '寵物保健品的研發門檻在學術依據較少，且許多人類可食用的成分對毛還具有淺在風險，在原料選用與標示格式上需特別注意， 更需留意出口國之當地市場規範，在兩國市場中，成份與法規皆需達到雙贏的目標。',
    solution: '我們投入大量時間查閱國際動物科學文獻及臨床實驗數據，為客戶篩選出具備科學實證的配方，並協助客戶確認原料合規性，依照台灣與出口國市場規範準備相關文件，協助品牌打造高品質、無負擔的專業及配方。',
    result: '系列產品順利 上市，產品不僅在國內市場獲得優異口碑，更協助客戶突破外銷限制，成功穩定出口至外國市場，品牌國際影響力顯著提升。',
  },
  {
    id: 3,
    tag: '兒童營養',
    tagColor: '#2e7d32',
    title: '兒童營養補充粉劑',
    subtitle: '針對兒童族群開發口感佳、成分安全的粉末補充品',
    img: 'https://readdy.ai/api/search-image?query=children%20health%20supplement%20powder%20nutrition%20stick%20packet%20colorful%20fruit%20flavored%20with%20vitamins%20minerals%20on%20white%20background%2C%20kids%20health%20food%20product%20photography&width=600&height=400&seq=case-kids-01&orientation=landscape',
    background: '品牌主長期關注社會公益，特別是兒童發展議題，為讓更多發育中的兒童獲得充足且均衡的營養支持，品牌主計推出一系列天然、健康為核心價值的營養補充粉。',
    challenge: '兒童成長所需營養範疇極廣，包含鈣質、維生素及益智成分，如何調整多種天然素材的精準配比，同時不添加人工香料與色素，又能符合兒童挑剔的口味，是本次專案最具挑戰性的環節。',
    solution: '我們嚴選多種專利天然素材，針對兒童成長取限設計功能性搭配，在口味調整上，我們捨去化學添加物，改以天然果粉提味，並反覆測試溶解度與口感，打造出營養密度高且受孩子歡迎的天然粉劑，實現營養與美味並存的目標。',
    result: '透過專業配方的加持，成功讓更多兒童能獲得優質的成長營養，而此產品也成為品牌公益活動的強力後盾，在推廣品牌價值的同時，也為兒童公益事業盡一份心力。',
  },
  {
    id: 4,
    tag: '廣播電台聯名',
    tagColor: '#43a047',
    title: '廣播電台的高品質魚油',
    subtitle: '與知名廣播媒體合作，打造高純度 Omega-3 魚油系列',
    img: 'https://readdy.ai/api/search-image?query=premium%20omega3%20fish%20oil%20capsules%20high%20purity%20supplement%20bottle%20with%20ocean%20sea%20background%2C%20high%20quality%20health%20product%20professional%20photography%20clean%20white%20minimal&width=600&height=400&seq=case-fishoil-01&orientation=landscape',
    background: '某知名廣播電台 擁有極高忠誠度的高齡聽眾群，考量到長輩對健康資訊的強烈需求， 決定推出自有的保健品，希望提供一款真正高品質、值得信賴的深海魚油，以回饋聽眾的長期支持。',
    challenge: '市面上魚油品牌林立，且核心原料來源多掌握在全球幾家大廠手中，市場價格透明度高，如何在眾多競品中展現差異化優勢，同時在高品質要求下精準管控成本，是此合作主要面臨的挑戰。',
    solution: '我們為客戶提供專案進口方案，直接引進北歐頂級純淨於由原料，從純度標準、重金屬檢測到 Omega 3 濃度，皆採取業界最高規格。協助客戶開闢專屬的高品質銀髮養生賽道，從源頭確保產品競爭力。',
    result: '由於產品質量卓越且具備極佳的信任感，首播推廣即創下亮眼成績，單次批次生產數量迅速突破6,000 盒，成為該電台最受歡迎的指標性健康產品。',
  },
  {
    id: 5,
    tag: '農業特色聯名',
    tagColor: '#1b5e20',
    title: '結合農業特色的保健品系列',
    subtitle: '將在地農業原料轉化為高附加值保健品，打造地方特色品牌',
    img: 'https://readdy.ai/api/search-image?query=local%20agriculture%20specialty%20health%20supplement%20Taiwan%20indigenous%20ingredients%20taro%20sweet%20potato%20rice%20extract%20natural%20products%20on%20wooden%20table%2C%20farm%20to%20table%20health%20food%20concept%20photography&width=600&height=400&seq=case-agri-01&orientation=landscape',
    background: '客戶擁有高品質的自家農場，生產具有獨特風味的農產品，為提升農業附加價值，客戶希望將自家優質農產轉化為高附加價值的保健品，創造與土地連結的品牌形象。',
    challenge: '將原始農產品 如特定蔬果或藥用植物 轉化為保健品時，如何保留農產原有的獨特風味，卻又不干擾保健配方中有效成分的穩定性，並兼顧大眾口味的接受度，是一項精細的調配工藝。',
    solution: '我們扮演了「農業與生醫的橋樑」，協助調整配方比例，將客戶自產的特色農產原料與現代營養科學完美融合，不僅確保風味的獨特性，更在產品開發過程中提供法規諮詢，確保產品宣稱與定位完全符合法規規範。',
    result: '產品規劃不僅精準對接法律規範，更展現了鮮明的品牌長期定位，這系列產品成功將農業特色品牌化，讓消費者在追求健康的同時，也能品嘗到來自土地的自然風味。',
  },
];

export default function CasesContent() {
  const [expanded, setExpanded] = useState<number | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const caseId = parseInt(id.replace('case-', ''), 10);
      if (!isNaN(caseId)) {
        setExpanded(caseId);
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 150);
      }
    }
  }, [location.hash]);

  return (
    <>
      {/* Hero Banner */}
      <section className="relative pt-20 min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20collection%20of%20health%20supplement%20products%20bottles%20capsules%20powders%20lined%20up%20on%20clean%20white%20background%2C%20professional%20health%20brand%20showcase%20product%20photography%2C%20natural%20light&width=1920&height=420&seq=cases-hero-bg-01&orientation=landscape"
            alt="成功案例背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <div className="mb-5">
              <div className="inline-block bg-black/8 backdrop-blur-sm rounded-lg px-3 py-1.5" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>
                <Breadcrumb
                  items={[
                    { label: '首頁', href: '/' },
                    { label: '關於康永', href: '/about' },
                    { label: '成功案例' },
                  ]}
                  textClassName="text-white"
                />
              </div>
            </div>
            <span className="inline-block bg-[#4CAF50]/30 border border-[#4CAF50]/40 text-white text-[0.875rem] font-semibold px-4 py-1.5 rounded-full mb-5 shadow-[0_1px_3px_rgba(0,0,0,0.2)]">
              關於康永
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              成功案例
            </h1>
            <p className="text-white text-[0.9375rem] md:text-[1.0625rem] leading-[1.75] max-w-3xl" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.45)' }}>
              多元產品類別、豐富代工經驗，以下為康永生技部分代表性合作案例。
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white border-b border-gray-100">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { num: '250+', label: '服務品牌數' },
              { num: '3,200+', label: '累計代工品項' },
              { num: '6+', label: '生產劑型' },
              { num: '10+', label: '出口目標市場' },
            ].map((s) => (
              <div key={s.label}>
                <p className="text-[#4CAF50] font-bold text-[2rem] md:text-[2.5rem] leading-none mb-1">{s.num}</p>
                <p className="text-gray-500 text-[0.875rem]">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cases list */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              代工案例
            </span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] mb-4">精選合作案例</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              點擊案例可展開詳細的合作背景、挑戰與成果說明
            </p>
          </div>

          <div className="space-y-5">
            {cases.map((c) => (
              <div
                key={c.id}
                id={`case-${c.id}`}
                className={`bg-white rounded-2xl border overflow-hidden transition-all duration-300 ${
                  expanded === c.id ? 'border-[#4CAF50]/40' : 'border-gray-100 hover:border-green-200'
                }`}
              >
                {/* Card header */}
                <button
                  className="w-full text-left cursor-pointer"
                  onClick={() => setExpanded(expanded === c.id ? null : c.id)}
                >
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 p-6">
                    {/* Image thumbnail */}
                    <div className="w-full sm:w-[160px] h-[120px] sm:h-[100px] flex-shrink-0 rounded-xl overflow-hidden">
                      <img src={c.img} alt={c.title} className="w-full h-full object-cover object-top" />
                    </div>
                    {/* Info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-2 mb-2">
                        <span
                          className="inline-block text-[0.75rem] font-medium px-3 py-1 rounded-full text-white"
                          style={{ backgroundColor: c.tagColor }}
                        >
                          {c.tag}
                        </span>
                        <span className="text-gray-300 text-xs">案例 0{c.id}</span>
                      </div>
                      <h3 className="text-[#1a2e1a] font-bold text-[1.125rem] mb-1">{c.title}</h3>
                      <p className="text-gray-500 text-[0.875rem] leading-[1.6] line-clamp-2">{c.subtitle}</p>
                    </div>
                    {/* Toggle */}
                    <div
                      className={`w-9 h-9 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${
                        expanded === c.id ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'
                      }`}
                    >
                      <i className={`text-sm ${expanded === c.id ? 'ri-subtract-line' : 'ri-add-line'}`} />
                    </div>
                  </div>
                </button>

                {/* Expanded detail */}
                {expanded === c.id && (
                  <div className="px-6 pb-7 border-t border-gray-100 pt-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {[
                        { label: '合作背景', icon: 'ri-information-line', content: c.background },
                        { label: '主要挑戰', icon: 'ri-error-warning-line', content: c.challenge },
                        { label: '康永的協作方式', icon: 'ri-tools-line', content: c.solution },
                        { label: '合作成果', icon: 'ri-trophy-line', content: c.result },
                      ].map((block) => (
                        <div key={block.label} className="bg-[#f7faf7] rounded-xl p-5">
                          <div className="flex items-center gap-2 mb-3">
                            <div className="w-7 h-7 flex items-center justify-center">
                              <i className={`${block.icon} text-[#4CAF50] text-base`} />
                            </div>
                            <h4 className="text-[#1a2e1a] font-bold text-[0.9375rem]">{block.label}</h4>
                          </div>
                          <p className="text-gray-600 text-[0.875rem] leading-[1.75]">{block.content}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            您的品牌，也可以是下一個成功案例
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            無論您的產品構想大小，康永生技都願意認真對待每一個合作機會。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              聯絡我們開始合作
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看代工服務
            </Link>
          </div>
        </div>
      </section>
      <RelatedPages items={[
        { title: '核心優勢', desc: '了解康永天然選材、健康三贏、整合式服務等四大核心優勢。', href: '/about/core-advantages' },
        { title: '合作流程', desc: '從需求對焦到交貨，清楚掌握合作的每個步驟。', href: '/cooperation/process' },
        { title: '立即洽詢', desc: '填寫諮詢表單，成為下一個康永協助就市的品牌。', href: '/cooperation/inquiry' },
      ]} />
    </>
  );
}
